<div class="image-box">
  <a class="btn btn-icon btn-danger btn-xs btn-close" (click)="removeImage()" *ngIf="!isDisabled">
    <i class="icon-xs la la-remove"></i>
  </a>
  <div class="preview" (click)="onClick()">
    <input #imageInput [id]="id" type="file" [name]="name" accept="image/*" [hidden]="true" (change)="processFile(imageInput)" />
    <img [src]="imageUrl$ | async" class="img-responsive img-fit-cover" *ngIf="imageUrl$ | async" />
    <div *ngIf="!(imageUrl$ | async)" class="kt-demo-icon">
      <div class="kt-demo-icon__preview">
        <i class="la la-cloud-upload"></i>
      </div>
    </div>
  </div>
</div>